import styled, { css } from 'styled-components';
import { ServiceName } from '../delivery-option-card.styles';
import { FontSizes } from '../../../../common/typography/typography.styles';
import { TagContainer } from '../../../../common/tag/tag.styles';

export const DeliveryOptionCardLeftContainer = styled.div`
  width: 100%;
  padding: 1.6rem 0 0 0;
  display: flex;
  flex: 2;
  gap: 2px;
  flex-direction: column;
  justify-content: space-around;
  color: ${({ theme }) => theme.colors.baseColors.grey100};
  font-size: ${FontSizes.small};
  font-weight: 500;
  line-height: 1.6rem;
  letter-spacing: 0.5px;

  ${TagContainer} {
    flex-shrink: 0;
    white-space: nowrap;
  }

  @media (max-width: 650px) {
    padding: 1.6rem 1.2rem 0 1.2rem;
  }
`;

export const MileDetailsContainer = styled.div<{ $hasMilesSelector: boolean }>`
  width: 100%;
  cursor: ${({ $hasMilesSelector }) =>
    $hasMilesSelector ? 'pointer' : 'default'};
  display: flex;
  flex-grow: 1;
  position: relative;
  justify-content: space-between;
  align-items: center;
  border-radius: 10px;
  padding: 8px;
  transform: translateY(-7px);
  ${ServiceName} {
    color: ${({ theme }) => theme.colors.baseColors.grey150};
  }
  button {
    width: 3.2rem;
    min-width: 3.2rem;
    max-width: 3.2rem;
    flex: 0 0 3.2rem;
    min-height: 3.2rem;
  }
  div {
    flex-grow: 1;
  }

  ${({ $hasMilesSelector, theme }) => {
    if (!$hasMilesSelector) return;
    return css`
      &:hover,
      &:active {
        background-color: ${theme.colors.baseColors.grey5};
      }
    `;
  }}
`;

export const DeliveryProgressContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 4px;
  justify-content: center;
  align-items: center;
  svg {
    width: 1.6rem;
    height: 1.6rem;

    path {
      fill: ${({ theme }) => theme.colors.namedColors.primary};
    }
  }
`;

export const DeliveryProgressLine = styled.div`
  width: 2px;
  background-color: ${({ theme }) => theme.colors.baseColors.grey50};
  height: 5.4rem;
`;
